export const AUTHOR_INFO_NAME = 'author name';
